
(function(){
  const $=(s,r=document)=>r.querySelector(s), $$=(s,r=document)=>Array.from(r.querySelectorAll(s));

  // Reveal animations
  const candidates=$$('.section, .product-card, .quality-card, .education-card, .contact-card, .faq-list details, .notice, .rte > *');
  candidates.forEach(el=>el.classList.add('tpg-reveal'));
  if('IntersectionObserver' in window){
    const io=new IntersectionObserver(entries=>{
      entries.forEach(e=>{
        if(e.isIntersecting){e.target.classList.add('tpg-in');io.unobserve(e.target);}
      });
    },{threshold:.07});
    candidates.forEach(el=>io.observe(el));
  } else candidates.forEach(el=>el.classList.add('tpg-in'));

  // Card lift
  $$('.product-card, .quality-card, .education-card, .contact-card').forEach(el=>el.classList.add('tpg-lift'));

  // Progress + top
  const progress=$('[data-tpg-progress]'), top=$('[data-tpg-top]');
  function scrollUI(){
    const max=document.documentElement.scrollHeight-innerHeight;
    if(progress) progress.style.width=(max>0?Math.min(100,scrollY/max*100):0)+'%';
    if(top) top.classList.toggle('is-visible',scrollY>500);
  }
  addEventListener('scroll',scrollUI,{passive:true}); scrollUI();
  if(top) top.addEventListener('click',()=>scrollTo({top:0,behavior:'smooth'}));

  // Toast
  const toast=$('[data-tpg-toast]'); let toastTimer;
  function showToast(msg){
    if(!toast)return;
    toast.textContent=msg; toast.classList.add('is-visible');
    clearTimeout(toastTimer); toastTimer=setTimeout(()=>toast.classList.remove('is-visible'),2400);
  }

  // Search
  const overlay=$('[data-tpg-search]'), input=$('[data-tpg-search-input]'), results=$('[data-tpg-search-results]');
  function openSearch(){
    if(!overlay)return;
    overlay.classList.add('is-open'); overlay.setAttribute('aria-hidden','false');
    setTimeout(()=>input&&input.focus(),40);
  }
  function closeSearch(){
    if(!overlay)return;
    overlay.classList.remove('is-open'); overlay.setAttribute('aria-hidden','true');
  }
  window.tpgOpenSearch=openSearch;
  window.tpgCloseSearch=closeSearch;
  document.addEventListener('click',e=>{
    if(e.target.closest('[data-open-search]')){e.preventDefault();openSearch();}
    if(e.target===overlay || e.target.closest('[data-tpg-search-close]'))closeSearch();
  });
  document.addEventListener('keydown',e=>{
    if((e.metaKey||e.ctrlKey)&&e.key.toLowerCase()==='k'){e.preventDefault();openSearch();}
    if(e.key==='Escape')closeSearch();
  });
  let timer;
  async function doSearch(q){
    if(!results)return;
    q=q.trim();
    if(!q){results.innerHTML='<div class="tpg-search-empty">Start typing to search.</div>';return;}
    results.innerHTML='<div class="tpg-search-empty">Searching…</div>';
    try{
      const r=await fetch('/search/suggest.json?q='+encodeURIComponent(q)+'&resources[type]=product,page&resources[limit]=10&resources[options][unavailable_products]=hide');
      const d=await r.json();
      const items=[...(d.resources?.results?.products||[]),...(d.resources?.results?.pages||[])];
      results.innerHTML=items.length ? items.map(x=>'<a href="'+x.url+'"><span>'+x.title+'</span><span>↗</span></a>').join('') : '<div class="tpg-search-empty">No matching results.</div>';
    }catch(e){results.innerHTML='<div class="tpg-search-empty">Search is temporarily unavailable.</div>';}
  }
  if(input) input.addEventListener('input',()=>{clearTimeout(timer);timer=setTimeout(()=>doSearch(input.value),180);});

  // Smooth same-page anchors
  document.addEventListener('click',e=>{
    const a=e.target.closest('a[href^="#"]'); if(!a)return;
    const id=a.getAttribute('href'); if(!id||id==='#')return;
    const target=$(id); if(target){e.preventDefault();target.scrollIntoView({behavior:'smooth',block:'start'});}
  });

  // Add-to-cart feedback. Does not block native Shopify submission.
  document.addEventListener('submit',e=>{
    const form=e.target;
    if(!form.matches('form[action*="/cart/add"]'))return;
    const btn=$('button[type="submit"],input[type="submit"]',form);
    if(!btn||btn.disabled)return;
    const old=btn.innerHTML;
    setTimeout(()=>{
      if(document.visibilityState==='visible'){
        btn.innerHTML='Added ✓'; showToast('Added to your cart');
        setTimeout(()=>btn.innerHTML=old,1700);
      }
    },450);
  });

  // Product image zoom class
  $$('.product-media, .product-card__image, .card__media').forEach(el=>el.classList.add('tpg-image-zoom'));

  // Close open FAQ sibling panels
  document.addEventListener('toggle',e=>{
    if(!e.target.matches('.faq-list details')||!e.target.open)return;
    const p=e.target.parentElement;
    $$('details[open]',p).forEach(d=>{if(d!==e.target)d.open=false});
  },true);
})();

  // FAQ dropdowns: keep the experience clean by closing other questions in the same group.
  document.addEventListener('toggle',function(e){
    if(!e.target.matches('.tpg-faq-dropdown') || !e.target.open) return;
    document.querySelectorAll('.tpg-faq-dropdown[open]').forEach(function(item){
      if(item !== e.target) item.open=false;
    });
  },true);
